import customAxios from "../../customAxios";

import { LOCATION_NEIGHBORHOOD } from "../../routes";
import {locationNamespace} from "../../../types/location.namespace";

const getOneNeighborhood = async (_id: string): Promise<any> => {
  let thisUrl = `${LOCATION_NEIGHBORHOOD}/${_id}`;

  try {
    return (await customAxios.get(thisUrl)).data;
  } catch (error: any) {
    console.log({LOCATION_NEIGHBORHOOD: error});
  }
};

export default getOneNeighborhood;
